import { get_project_info_localStorage } from "src/DAL/localStorage/localStorage";
import { update_root_value } from "src/utils/domUtils";
import applyTokens from "src/design-system/applyTokens";
import { tokens } from "src/design-system/tokens";

export const baseUri = process.env.REACT_APP_API_BASE_URL;
export const s3baseUrl = process.env.REACT_APP_PIC_BASE_URL;
export const socketUrl = process.env.REACT_APP_SOCKET_URL;
export const project_name = "BMS-gym";
export const websiteBaseUrl = process.env.REACT_APP_WEBSITE_BASE_URL;
export const api_key = process.env.REACT_APP_WEB_API_KEY;

// Harmony Ring (programme compliance ring / graph, "Harmony Member", non-compliant highlight in the
// members list) is hidden for now: client asked to simplify. To bring it back set
// REACT_APP_HARMONY_RING_ENABLED=true in the .env file and rebuild. The backend is unchanged.
export const harmonyRingEnabled =
  process.env.REACT_APP_HARMONY_RING_ENABLED === "true";

const get_project_info = get_project_info_localStorage();
export const material_theme_palate = {
  lighter: tokens.color.brand,
  light: tokens.color.brand,
  main: tokens.color.brand,
  dark: tokens.color.brand,
  darker: tokens.color.brand,
  contrastText: "#fff",
};

export const OwnerName = () => {
  return "GymRite";
};

export const ownerName = "GymRite's";
export const ownerCompleteName = "GymRite";

export const get_app_logo = () => {
  if (get_project_info && get_project_info.brand_logo) {
    return s3baseUrl + get_project_info.brand_logo;
  } else {
    return "";
  }
};

export const get_app_headers = () => {
  if (get_project_info && get_project_info.meta_title) {
    return {
      title: get_project_info.meta_title,
      description: get_project_info.meta_description,
      fav_icon: s3baseUrl + get_project_info.brand_favicon,
    };
  } else {
    return {
      title: "GymRite | Client",
      description: "GymRite | Client",
      fav_icon: "",
    };
  }
};

material_theme_palate.main = tokens.color.brand;
/* Main theme color */
update_root_value("--portal-theme-primary", tokens.color.brand);
update_root_value("--portal-theme-secondary", "#04abbb17");
update_root_value("--text-primary-color", "black");
update_root_value("--text-secondary-color", "rgb(150, 150, 150)");
update_root_value("--text-color", "black");

/* Main background color*/
update_root_value("--background-primary-color", "#fff");
update_root_value("--background-secondary-color", "#fff");

/* Sidebar Properties */
update_root_value("--sidebars-text-color", "black");
update_root_value("--sidebars-active-color", "#C19D60");
// Was "--sidebars-hover-color:" (trailing colon), so it never applied; #04abbb is the value in effect (from :root).
update_root_value("--sidebars-hover-color", tokens.color.brand);
update_root_value("--sidebars-background-color", "#ffffff");

/* Popup / Popover properties  */
update_root_value("--popup-background-color", "white");
update_root_value("--popup-text-color", tokens.color.brand);

/* Element properties */
update_root_value("--input-text-color", "black");
update_root_value("--input-placeholder-color", "#fff");
update_root_value("--input-background-primary", "#fff");
update_root_value("--input-background-secondary", "#1d1c1d");
// Was " --icons-color-allover" (leading space), so it never applied; #04abbb is the value in effect (from :root).
update_root_value("--icons-color-allover", tokens.color.brand);

/* Button Properties */

update_root_value("--button-background-color", tokens.color.brand);
update_root_value("--button-text-color", "#fff");
update_root_value("--button-outlined-color", tokens.color.brand);
update_root_value("--button-hover-color", tokens.color.brand);

/* Audio Properties */
update_root_value("--audio-color", "rgb(56, 54, 54)");

/* calendar Properties */
update_root_value("--calendar-selected-box", "#8b8b8b");

/* Known typo, left as is on purpose: index.css uses var(--sidebars-backgroung-color) in
   .card-width, .card-billing and .add-earning-drawer. It is undefined, so those backgrounds are
   transparent today; defining it would repaint them. Fix inside their module task. */

/* GymRite design tokens (--gr-*): the only source for the new Design Elements. */
applyTokens();
